/**
 * Mount / unmount auth Drive Preact UI + host (upload/keyboard/lightbox).
 * Side pages use mountSidePage.js when #drive-side-preact-root exists.
 */
import { render, h } from 'preact'
import { I18n } from 'i18n-js'
import locales from '../../locales.json'
import { createDriveStore } from './drive-store.js'
import { DriveSession } from './session.js'
import { DriveApp } from '../../components/drive/DriveApp.jsx'
import { mountDriveSidePage, unmountDriveSidePage } from './mountSidePage.js'

let activeSession = null
let activeRoot = null

function readProps(root) {
  const raw = root.dataset.driveProps
  if (!raw) return {}
  try {
    return JSON.parse(raw)
  } catch (e) {
    console.error('[drive] invalid data-drive-props', e)
    return {}
  }
}

export function mountDrive() {
  if (mountDriveSidePage()) return

  const root = document.getElementById('drive-controller')
  if (!root) return
  if (root.dataset.driveMounted === '1' && activeSession) return

  unmountDrive()

  const props = readProps(root)
  const i18n = new I18n(locales)
  i18n.locale = document.querySelector("meta[name='locale']")?.content || 'hu'
  const store = createDriveStore()

  const host = new DriveSession(root, {
    ...props,
    store,
    i18n,
    skipRender: true
  })

  render(
    h(DriveApp, {
      store,
      i18n,
      host,
      canCreate: !!props.canCreate,
      canUpdate: !!props.canUpdate,
      canDestroy: !!props.canDestroy,
      canTagFiles: !!props.canTagFiles,
      editorEnabled: !!props.editorEnabled,
      onlyOfficeEntitled: !!props.onlyOfficeEntitled,
      onlyOfficeLockTitle: props.onlyOfficeLockTitle || '',
      onlyOfficeUpgradePath: props.onlyOfficeUpgradePath || '',
      webdavEnabled: !!props.webdavEnabled,
      publicShareAllowed: !!props.publicShareAllowed,
      publicShareLockTitle: props.publicShareLockTitle || '',
      publicShareUpgradePath: props.publicShareUpgradePath || '',
      storageQuota: props.storageQuota || null
    }),
    root
  )

  host.start()
  activeSession = host
  activeRoot = root
  root.dataset.driveMounted = '1'
  window._driveSession = host
}

export function unmountDrive() {
  unmountDriveSidePage()

  if (activeSession) {
    activeSession.stop()
    activeSession = null
  }
  if (activeRoot) {
    render(null, activeRoot)
    delete activeRoot.dataset.driveMounted
    activeRoot = null
  } else {
    const root = document.getElementById('drive-controller')
    if (root) {
      render(null, root)
      delete root.dataset.driveMounted
    }
  }
  if (window._driveSession) delete window._driveSession
  if (window._driveUi) delete window._driveUi
}

export function remountDrive() {
  unmountDrive()
  mountDrive()
}
